import { Color } from "../../defines/colors"
import { PopupID } from "../../defines/enums"
import { Symbol } from "../../defines/symbols"
import { Position, RenderConfig } from "../../defines/types"
import { Entity } from "../entity"

export class PopupTrigger extends Entity {
  constructor(public target: PopupID, position: Position) {
    const render = triggerRenderConfig(target)
    super(position, true, render, "Entrance to " + popupIDToString(target))
  }
}

function popupIDToString(target: PopupID): string {
  let tag = ""

  switch (target) {
    case PopupID.TAPESTRY:
      tag = "Tapestry Room"
      break
    case PopupID.ARCHIVE:
      tag = "Archive"
      break
    case PopupID.BESTIARY:
      tag = "Bestiary"
      break
    case PopupID.ARSENAL:
      tag = "Arsenal"
      break
    case PopupID.WARDROBE:
      tag = "Wardrobe"
      break
    case PopupID.COMMON_FINDS:
      tag = "Common Finds"
      break
    case PopupID.MYTHIC_FINDS:
      tag = "Mythic Finds"
      break
    case PopupID.GIZMOS:
      tag = "Gizmos"
      break
    default:
      break
  }

  return tag
}

function triggerRenderConfig(target: PopupID): RenderConfig {
  let symbol = ""

  switch (target) {
    case PopupID.TAPESTRY:
      symbol = Symbol.TAPESTRY
      break
    case PopupID.ARCHIVE:
      symbol = Symbol.ARCHIVE
      break
    case PopupID.BESTIARY:
      symbol = Symbol.BESTIARY
      break
    case PopupID.ARSENAL:
      symbol = Symbol.ARSENAL
      break
    case PopupID.WARDROBE:
      symbol = Symbol.WARDROBE
      break
    case PopupID.COMMON_FINDS:
      symbol = Symbol.COMMON_FINDS
      break
    case PopupID.MYTHIC_FINDS:
      symbol = Symbol.MYTHIC_FINDS
      break
    case PopupID.GIZMOS:
      symbol = Symbol.GIZMOS
      break
    default:
      break
  }

  return {
    symbol: [symbol],
    light: Color.TRIGGER_LIGHT,
    dark: Color.TRIGGER_DARK,
  }
}
